/** Configuração da skill ticket_preseller (espelha backend). */

export const PRESSELLER_FIELD_ORDER = [
  "origem",
  "destino",
  "tipo_viagem",
  "data_ida",
  "data_volta",
  "quantidade_passageiros",
  "perfil_passageiros",
  "condicoes_especiais",
  "dados_passageiros",
  "lookup_cpf",
];

export const DEFAULT_PRESSELLER_FIELDS = [
  { key: "origem", enabled: true, required: true },
  { key: "destino", enabled: true, required: true },
  { key: "tipo_viagem", enabled: true, required: true },
  { key: "data_ida", enabled: true, required: true },
  { key: "data_volta", enabled: true, required: false },
  { key: "quantidade_passageiros", enabled: true, required: true },
  { key: "perfil_passageiros", enabled: true, required: true },
  { key: "condicoes_especiais", enabled: true, required: true },
  { key: "dados_passageiros", enabled: true, required: true },
  { key: "lookup_cpf", enabled: true, required: false },
];

export const PRESSELLER_DEFAULT_MESSAGES = {
  intro_message:
    "Olá! Vou coletar alguns dados da sua viagem e em seguida um atendente continua com você.",
  transfer_message:
    "Perfeito! Já anotei tudo e vou te encaminhar para um atendente finalizar sua passagem.",
};

/**
 * Normaliza campos de coleta preservando a ordem salva em `collection_fields`.
 * Campos conhecidos ausentes no JSON entram no final com defaults.
 */
export function normalizePresellerFields(config) {
  const raw =
    Array.isArray(config?.collection_fields) && config.collection_fields.length
      ? config.collection_fields
      : null;
  const byKey = Object.fromEntries(DEFAULT_PRESSELLER_FIELDS.map((d) => [d.key, { ...d }]));
  const ordered = [];
  const seen = new Set();

  if (raw) {
    for (const row of raw) {
      if (!row?.key || !byKey[row.key] || seen.has(row.key)) continue;
      seen.add(row.key);
      byKey[row.key] = {
        key: row.key,
        enabled: row.enabled !== false,
        required: row.required !== false,
      };
      ordered.push(byKey[row.key]);
    }
  }

  for (const key of PRESSELLER_FIELD_ORDER) {
    if (seen.has(key)) continue;
    ordered.push(byKey[key]);
  }

  return ordered;
}

/** Move um campo na lista (índices 0-based). */
export function movePresellerField(fields, fromIndex, toIndex) {
  const list = Array.isArray(fields) ? [...fields] : [];
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= list.length ||
    toIndex >= list.length ||
    fromIndex === toIndex
  ) {
    return list;
  }
  const [item] = list.splice(fromIndex, 1);
  list.splice(toIndex, 0, item);
  return list;
}

export function presellerFieldLabelKey(key) {
  return `agentsListPage.presellerField_${key}`;
}

export function presellerFieldHelperKey(key) {
  return `agentsListPage.presellerField_${key}_helper`;
}
